import { useEffect } from "react";

import { useGetTruckBrandsQuery, useGetTruckImplementsQuery, useLazyGetTruckModelsByBrandQuery } from "@/store";
import { transformInOptions } from "@/utils";

type UseTruckDataParams = {
  brandId: number;
};
export function useTruckData({ brandId }: UseTruckDataParams) {
  const brandsState = useGetTruckBrandsQuery(undefined, {
    selectFromResult: (state) => {
      return {
        ...state,
        data: {
          response: state.data,
          options: transformInOptions(state.data)
        }
      };
    }
  });
  const { data: truckImplements = [] } = useGetTruckImplementsQuery();
  const [getModelsByBrand, modelByBrandState] = useLazyGetTruckModelsByBrandQuery({
    selectFromResult: (state) => {
      return {
        ...state,
        data: {
          response: state.data,
          options: transformInOptions(state.data)
        }
      };
    }
  });

  useEffect(() => {
    if (brandId) {
      getModelsByBrand({ truckBrand: { id: brandId } });
    }
  }, [brandId]);

  return {
    state: {
      implements: truckImplements.map((item) => ({
        label: item!.name,
        value: item!.id
      }))
    },
    data: {
      brands: brandsState,
      modelByBrand: modelByBrandState
    }
  };
}
